import React from 'react';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { L10n } from '~src/ts/L10n/L10n';
import { IUserInfo } from '~src/ts/models/IUserInfo';

import { ContentDetailSection, DetailEditButton } from './ContentDetailSection';
import { DetailDialogUserDetail } from './DetailDialogUserLink';


export interface DateDetailSectionProps {
  readonly date: Date;
}

export function CreatedAtDetailSection(props: DateDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.created()}
      testId={'created-at'}
      detail={L10n.localizedDateTime(props.date)}
    />
  );
}

export interface ModifiedAtDetailSectionProps extends DateDetailSectionProps {
  readonly allowShowRevisionHistory?: boolean;
  readonly showRevisionHistory?: () => void;
}

export function ModifiedAtDetailSection(props: ModifiedAtDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.modified()}
      testId={'modified-at'}
      detail={L10n.localizedDateTime(props.date)}
      isActionAllowed={props.allowShowRevisionHistory}
      action={<DetailEditButton
        buttonLabel={Messages.revisionHistoryView()}
        buttonTestId={'show-revision-history'}
        onClickAction={props.showRevisionHistory}
      />}
    />
  );
}

export interface ModifiedByDetailSectionProps {
  readonly urls: SpacesSiteUrls;
  readonly user: IUserInfo;
}

export function ModifiedByDetailSection(props: ModifiedByDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.modifiedBy()}
      testId={'modified-by'}
      detail={!_.isEmpty(props.user) ?
        <DetailDialogUserDetail user={props.user} urls={props.urls} /> :
        ''
      }
    />
  );
}
